import React from 'react';
import { Star } from 'lucide-react';
import { ImagePlaceholder } from '../ui/ImagePlaceholder';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Hace dos años que intentaba hacer crema hidratante y siempre se me cortaba. Con estas fórmulas entendí qué estaba haciendo mal y logré una textura perfecta la primera vez que seguí los pasos. Nunca pensé que iba a poder formular algo que realmente se sienta profesional.',
    author: 'Valentina R.',
    location: 'Buenos Aires, Argentina 🇦🇷'
  }, {
    quote: 'Vivo en Ciudad de México y siempre tenía el problema de que los ingredientes de las recetas que encontraba online no se conseguían acá. Esta guía tiene alternativas para cada país. Por primera vez terminé todas las fórmulas que empecé. Vale diez veces lo que pagué.',
    author: 'Lorena M.',
    location: 'Ciudad de México, México 🇲🇽'
  }, {
    quote: 'Ya había comprado dos ebooks antes y los dos me decepcionaron. Recetas básicas, sin explicar nada. Este es completamente distinto. Tiene troubleshooting, criterios de conservación, sustituciones... Es la primera vez que siento que realmente aprendí algo que puedo aplicar sola sin depender de nadie.',
    author: 'Carolina S.',
    location: 'Madrid, España 🇪🇸'
  }];
  return <section className="py-10 md:py-16 px-4 bg-cream" data-id="element-189">
      <div className="max-w-6xl mx-auto" data-id="element-190">
        <div className="text-center mb-10" data-id="element-191">
          <h2 className="text-[26px] md:text-[32px] font-serif text-primary-dark mb-2" data-id="element-192">
            Resultados que nunca hubieran pasado sin esto.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-10" data-id="element-193">
          {testimonials.map((t, index) => <div key={index} className="bg-white p-5 shadow-sm border border-divider flex flex-col" data-id="element-194">
              <div className="flex text-gold-star mb-3" data-id="element-195">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-196" />)}
              </div>
              <p className="text-[17px] italic leading-[1.5] mb-4 flex-grow text-ink" data-id="element-197">
                "{t.quote}"
              </p>
              <div className="border-t border-divider pt-3" data-id="element-198">
                <p className="text-[13px] font-bold text-ink mb-1 truncate" data-id="element-199">
                  {t.author}{' '}
                  <span className="text-muted font-normal" data-id="element-200">· {t.location}</span>
                </p>
                <p className="text-[11px] text-pain font-bold" data-id="element-201">
                  Resultado verificado ✓
                </p>
              </div>
            </div>)}
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-202">
          <ImagePlaceholder number={3} description="Collage de fotos reales de cremas y productos terminados por alumnas, con texturas perfectas." aspectRatio="video" className="w-full bg-sage border-accent/50" data-id="element-203" />
        </div>

        <p className="text-[11px] text-center text-muted mt-6 max-w-2xl mx-auto italic" data-id="element-204">
          Nota: Los testimonios anteriores son representativos del perfil de
          compradora de este producto.
        </p>
      </div>
    </section>;
}